module.exports = __webpack_public_path__ + "img/faq-color.a0e11971.svg";